/* eslint-disable import/no-anonymous-default-export */
import React, { useEffect } from "react";
import { api } from "../../config/api";
import { util } from "../../config/util";
import { Cookies } from "../../constants/Cookies";

import Hero from "./components/Hero";
import CompanyBanner from "./components/CompanyBanner";
import Category from "./components/Category";
import Request from "./components/Request";
import AiFeatures from "./components/AiFeatures";
import RecommendLeture from "./components/RecommendLeture";
import MiddleBanner from "./components/MiddleBanner";
import styles from "./mainRedesign.module.scss";

interface Props {
  clearUserInfo: () => void;
}

export default (props: Props) => {
  useEffect(() => {
    if (util.getCookie(Cookies.authKey)) {
      api
        .getMyInfo()
        .then(() => {})
        .catch(() => {
          props.clearUserInfo();
        });
    }
  }, []);

  return (
    <main id="wrap" className={styles.mainWrap}>
      <article>
        <Hero />
        <CompanyBanner />
        <Category />
        <Request />
        <AiFeatures />
        <RecommendLeture />
        <MiddleBanner />
      </article>
    </main>
  );
};
